var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.56 2.17099C12.3946 2.05921 12.1996 1.99948 12 1.99948C11.8004 1.99948 11.6054 2.05921 11.44 2.17099L3.44 7.57099C3.30443 7.66262 3.19342 7.78613 3.11671 7.93066C3.03999 8.0752 2.99992 8.23635 3 8.39999V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V8.39999C21.0001 8.23635 20.96 8.0752 20.8833 7.93066C20.8066 7.78613 20.6956 7.66262 20.56 7.57099L12.56 2.17099ZM14 20H10V14H14V20ZM19 20H16V13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1053 15.2652 12 15 12H9C8.73478 12 8.48043 12.1053 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13V20H5V8.93199L12 4.20699L19 8.93199V20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fbc32b28766c86d04a057b3687756402.svg";
export { ForwardRef as ReactComponent };